import { render, staticRenderFns } from "./permission.vue?vue&type=template&id=17f8efad"
import script from "./permission.vue?vue&type=script&lang=js"
export * from "./permission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17f8efad')) {
      api.createRecord('17f8efad', component.options)
    } else {
      api.reload('17f8efad', component.options)
    }
    module.hot.accept("./permission.vue?vue&type=template&id=17f8efad", function () {
      api.rerender('17f8efad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/operation/permission.vue"
export default component.exports